import React, { useEffect, useRef } from "react";
import "./FestivalPostTabs.scss";
import { CommonEnums } from "../../../../enums/common.enums";

const FestivalPostTabs = ({
  activeTab,
  onTabChange,
}: {
  activeTab: string;
  onTabChange: (tab: string) => void;
}) => {
  const tabs = [
    {
      slug: CommonEnums.festivalPostTabs.post_type.key,
      label: CommonEnums.festivalPostTabs.post_type.value,
    },
    {
      slug: CommonEnums.festivalPostTabs.festival_type.key,
      label: CommonEnums.festivalPostTabs.festival_type.value,
    },
    {
      slug: CommonEnums.festivalPostTabs.select_template.key,
      label: CommonEnums.festivalPostTabs.select_template.value,
    },
    {
      slug: CommonEnums.festivalPostTabs.create_post.key,
      label: CommonEnums.festivalPostTabs.create_post.value,
    },
    {
      slug: CommonEnums.festivalPostTabs.configure_post.key,
      label: CommonEnums.festivalPostTabs.configure_post.value,
    },
  ];

  const activeIndex = tabs.findIndex((tab) => tab.slug === activeTab);
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (tabRefs.current[activeIndex]) {
      tabRefs.current[activeIndex]?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  return (
    <div className="tabs-scroll-container">
      <div className="tabs">
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.slug;
          const isCompleted = index < activeIndex;
          const isDisabled = index !== activeIndex;

          return (
            <div
              ref={(el) => (tabRefs.current[index] = el)}
              key={tab.slug}
              className={`tab ${isActive ? "active" : ""} ${
                isCompleted ? "completed" : ""
              } ${isDisabled ? "disabled" : ""}`}
              onClick={() => onTabChange(tab.slug)}
            >
              {tab.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FestivalPostTabs;
